import React, { useState, useEffect } from 'react';

import { API_BASE_URL } from '../../adminconfig';
const Contact = () => {
  const [contactData, setContactData] = useState([]);
  const [loading, setLoading] = useState(true);

  const tableHeaders = [
    'Full Name',
    'Email Address',
    'Mobile Number',
    'Institution Type',
    'Budget Range',
    'Designation',
    'Institution Name',
    'Project Details',
    'Updates Opted In',
    'Submitted At',
  ];
  const adminToken = typeof window !== "undefined" ? localStorage.getItem("adminToken") : null;
  const [selectedProject, setSelectedProject] = useState(null);

  const openModal = (details) => {
    setSelectedProject(details);
  };

  const closeModal = () => {
    setSelectedProject(null);
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/api/contact`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${adminToken}`, // ✅ Send token in header
          },
        });
        console.log("response=", response);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const data = await response.json();
        setContactData(data);
      } catch (error) {
        console.error("Failed to fetch contact data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (adminToken) {
      fetchData();
    }
  }, [adminToken]);


  return (
    <div className="p-6 bg-white rounded-xl shadow-lg">
      <h2 className="text-3xl font-bold text-gray-800 mb-4">
        Contact Submissions
      </h2>
      <p className="text-gray-600 mb-6">
        Here is a list of contact submissions received from the form.
      </p>

      {/* Y-scroll container */}
      <div className="max-h-[500px] max-w-[1300px] overflow-y-auto overflow-x-auto rounded-lg shadow-md">
        {loading ? (
          <div className="text-center py-10 text-gray-500">
            Loading data...
          </div>
        ) : contactData.length === 0 ? (
          <div className="text-center py-10 text-gray-500">
            No contact submissions found.
          </div>
        ) : (
          <table className="max-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                {tableHeaders.map((header) => (
                  <th
                    key={header}
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody className="bg-white divide-y divide-gray-200">
              {contactData.map((row, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition-colors duration-150"
                >
                  <td className="px-6 py-4 text-sm text-gray-900">{row.fullName}</td>
                  <td className="px-6 py-4 text-sm text-gray-700">{row.emailAddress}</td>
                  <td className="px-6 py-4 text-sm text-gray-700">{row.mobileNumber}</td>
                  <td className="px-6 py-4 text-sm text-gray-700">{row.instituteType}</td>
                  <td className="px-6 py-4 text-sm text-gray-700">{row.budgetRange || '-'}</td>
                  <td className="px-6 py-4 text-sm text-gray-700">{row.designation}</td>
                  <td className="px-6 py-4 text-sm text-gray-700">{row.institutionName}</td>
                  <td className="px-6 py-4 text-sm text-gray-700 max-w-[250px]">
                    <div className="flex flex-col">

                      {/* Truncated Text */}
                      <p className="truncate">
                        {row.projectDetails}
                      </p>

                      {/* Read More Button */}
                      {row.projectDetails?.length > 80 && (
                        <button
                          onClick={() => openModal(row.projectDetails)}
                          className="text-purple-600 text-xs mt-1 hover:underline text-left"
                        >
                          Read More
                        </button>
                      )}

                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {row.updatesOptIn ? 'Yes' : 'No'}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500">
                    {new Date(row.createdAt).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {selectedProject && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">

          {/* Modal Box */}
          <div className="bg-white w-[90%] max-w-2xl rounded-xl shadow-xl p-6 relative animate-fadeIn">

            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute top-3 right-3 text-gray-500 hover:text-black text-lg"
            >
              ✕
            </button>

            <h3 className="text-xl font-semibold mb-4">
              Project Details
            </h3>

            <div className="max-h-[400px] overflow-y-auto text-gray-700 leading-relaxed whitespace-pre-wrap">
              {selectedProject}
            </div>

            <div className="mt-6 text-right">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>

  );
};

export default Contact;
